module.exports = __webpack_public_path__ + "img/program-img_2.105d96f7.png";